import { Form, mapFormDispatchToEvents } from '@elab/components/connected/forms/Form';
import { COMPONENT_CONNECT, COMPONENT_DISCONNECT } from '@elab/core/utils/dynaReduxHelpers';
import connect from '@elab/core/store/connect';
import { actions as coreActions } from '@elab/core/store/core';
import { actions as socialActions } from '@elab/core/store/social';
import { actions as registrationActions } from '@elab/components/connected/forms/RegistrationForm/redux';

import storeNames from './storeNames';

const mapDispatchToEvents = (dispatch, ctx) => ({
    [COMPONENT_CONNECT]: () => {
        const storeName = ctx.storeName;
        let reducers = null;
        let saga = null;

        switch (storeName) {
            case storeNames.CHECKOUT_AUTH_OPTIONS:
                reducers = require('./redux/reducers').default(storeName);
                saga = require('./redux/saga').optionsSaga(storeName, ctx.formId);
                break;

            case storeNames.CHECKOUT_GUEST:
                reducers = require('../RegistrationForm/redux/reducers').default(storeName);
                saga = require('./redux/saga').guestSaga(storeName, ctx.formId);
                break;

            case storeNames.CHANGE_BILLING_ADDRESS_FORM:
                reducers = require('../RegistrationForm/redux/reducers').default(storeName);
                saga = require('./redux/saga').changeBillingAddress(storeName, ctx.formId);
                break;

            case storeNames.DELIVERY_ADDRESS_FOR_LOGGED_IN_USER_FORM:
                reducers = require('../RegistrationForm/redux/reducers').default(storeName);
                saga = require('./redux/saga').changeDeliveryAddress(storeName, ctx.formId);
                break;
            case storeNames.CHECKOUT_ADD_ADDRESS_FORM:
                reducers = require('../RegistrationForm/redux/reducers').default(storeName);
                saga = require('./redux/saga').changeDeliveryAddress(storeName, ctx.formId);
                break;
            case storeNames.CHECKOUT_GUEST_TO_LOGIN_FORM:
                reducers = require('./redux/reducers').default(storeName);
                saga = require('./redux/saga').checkoutGuestToLoginSaga(storeName, ctx.formId);
                break;
            default:
                reducers = require('../RegistrationForm/redux/reducers').default(storeName);
                saga = require('./redux/saga').registeredSaga(storeName, ctx.formId);
        }

        dispatch(coreActions.addReducer(storeName, reducers));
        dispatch(coreActions.addSaga(storeName, saga));
    },
    [COMPONENT_DISCONNECT]: () => {
        if (ctx.appId) {
            sessionStorage.removeItem(`fbssls_${ctx.appId}`);
        }
        sessionStorage.removeItem('googleAuthToken');
        dispatch(socialActions.setInitialSocialInfo());
        dispatch(registrationActions.setDataFieldValue('socialProfileId', null, true));
        dispatch(registrationActions.setDataFieldValue('socialProfileAccessToken', null, true));
        dispatch(registrationActions.setDataFieldValue('socialProfileProvider', null, true));
        dispatch(coreActions.removeSaga(ctx.storeName || ctx.formId));
        dispatch(coreActions.removeReducer(ctx.storeName || ctx.formId));
    },
    ...mapFormDispatchToEvents(dispatch, ctx),
});

export default () =>
    customElements.define('e2-checkout-form', connect(null, mapDispatchToEvents)(Form));
